"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function tracker({ trackEvent, }) {
    return (state, actions, { action, label }) => () => {
        trackEvent(action, label);
    };
}
exports.tracker = tracker;
//# sourceMappingURL=tracker.js.map